import { useState, useEffect, useCallback } from 'react';
import apiClient from '../api/apiClient';

export const useHubkomUsage = (locationId) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchUsage = useCallback(async () => {
    if (!locationId || locationId === 'all') {
      setIsLoading(false);
      return;
    }

    try {
      setIsLoading(true);
      setError(null);
      const response = await apiClient.get(`/api/billing/usage/hubkom/${locationId}`);
      setData(response);
    } catch (err) {
      console.error('Error fetching Hubkom usage:', err);
      setError(err.message || 'Failed to load usage data');
    } finally {
      setIsLoading(false);
    }
  }, [locationId]);

  useEffect(() => {
    fetchUsage();
  }, [fetchUsage]);

  const toggleOverage = useCallback(async (field, value) => {
    try {
      await apiClient.put(`/api/restaurants/${locationId}`, { [field]: value });
      await fetchUsage();
    } catch (err) {
      console.error('Error toggling overage:', err);
      throw err;
    }
  }, [locationId, fetchUsage]);

  return { data, isLoading, error, refetch: fetchUsage, toggleOverage };
};

export default useHubkomUsage;
